"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataForRequestFormsContext = void 0;
var _react = require("react");
var stub = function stub() {
  throw new Error('<DataForRequestFormsProvider> not found.');
};

/**
 * Контекст с данными из стора vitrins-frontend для использования в форме из package-vitrina-components.
 * Содержит фильтры, словари, источники данных, пользователя, текущее местоположение, eventCategory.
 */
var DataForRequestFormsContext = (0, _react.createContext)({
  eventCategory: stub,
  filters: stub,
  dataSources: stub,
  configDictionaries: stub,
  dictionaries: stub,
  location: stub,
  user: stub,
  query: stub,
  party: stub,
  address: stub
});
exports.DataForRequestFormsContext = DataForRequestFormsContext;
DataForRequestFormsContext.displayName = 'DataForRequestFormsContext';